export const USER_ROLES = ['admin', 'reviewer'];
//# sourceMappingURL=UserRole.js.map